<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card v-if="ay_std_div_list != null" class="box mb-4">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Admitted Student Profile Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                            :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd()"
                            persistent-hint hint="Select Academic Year " />
                    </v-col>
                    <v-col sm="2" v-if="std_div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                            :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv"
                            persistent-hint hint="Select Standard " />
                    </v-col>
                    <v-col sm="2" v-if="div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object
                            :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                            hint="Select Division" />
                    </v-col>
                    <v-col sm="2" v-if="sel_ay_data && sel_std_data">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                            item-text="name" return-object label="Status" outlined @change="check_values"
                            persistent-hint hint="Select Status" />
                    </v-col>
                    <v-col sm="2" v-if="sel_ay_data && sel_std_data && status">
                        <v-btn class="mt-7 button" color="primary" @click="getStudentList()" :loading="fetch_btn_load" small>
                            Fetch Students
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-expand-transition>
            <v-card class="box mb-4" v-if="student_list && student_list.length > 0">
                <v-card-text>
                    
                    <v-row justify="center" class="mb-2" dense>
                        <v-col cols="12" sm="6" md="4">
                            <v-autocomplete 
                                v-model="selected_student" 
                                :items="student_list" 
                                item-text="name" 
                                return-object 
                                label="Select Student" 
                                outlined dense color="#0F2027" 
                                prepend-inner-icon="mdi-magnify"
                                hide-details
                            ></v-autocomplete>
                        </v-col>
                         <v-col sm="2" v-if="sel_ay_data && sel_std_data && status">
                            <v-btn class="button" color="primary" @click="getAdmittedReport" :loading="fetch_student" small>
                                Fetch
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <!-- <v-row justify="center" dense>
                        <v-col sm="2">
                            <v-switch color="#0F2027" v-model="all_toggle" label="Toggle All"></v-switch>
                        </v-col>
                    </v-row> -->

                    <div class="field-selection-wrapper">

                        <div class="field-selection-header">
                            <div>
                                <div class="field-selection-title">
                                    Select Report Fields
                                </div>
                                <div class="field-selection-subtitle">
                                    Select the fields you want to display in the report
                                </div>
                            </div>

                            <div class="global-select">
                                <v-switch v-model="all_toggle" color="#0F2027" inset hide-details class="ma-0 pa-0" @change="toggleAllFields">
                                    <template v-slot:label>
                                        <span class="global-select-label">
                                            Select All Fields
                                        </span>
                                    </template>
                                </v-switch>
                            </div>
                        </div>


                        <div v-for="(category, catIndex) in fieldCategories" :key="'category-' + catIndex"
                            class="field-category">

                            <div class="category-header">

                                <div class="category-title-wrapper">
                                    <div class="category-icon">
                                        <v-icon small color="#0F2027">
                                           {{category.icon}}
                                        </v-icon>
                                    </div>

                                    <div>
                                        <div class="category-title">
                                            {{ category.title }}
                                        </div>

                                        <div class="category-count">
                                            {{ getSelectedCount(category) }} /
                                            {{ category.fields.length }}
                                            fields selected
                                        </div>
                                    </div>
                                </div>


                                <div class="category-select-all">

                                    <v-checkbox v-model="category.selectAll" color="#0F2027" dense hide-details
                                        class="ma-0 pa-0" @change="toggleCategory(category)">
                                        <template v-slot:label>
                                            <span class="select-all-label">
                                                Select All
                                            </span>
                                        </template>
                                    </v-checkbox>

                                </div>

                            </div>


                            <div class="category-fields">

                                <v-row dense>

                                    <v-col cols="12" sm="6" md="4" lg="3" v-for="(item, itemIndex) in category.fields"
                                        :key="'field-' + catIndex + '-' + itemIndex">

                                        <div class="field-item" :class="{
                                            'field-item-selected': field[item.model]
                                        }">

                                            <v-checkbox v-model="field[item.model]" color="#0F2027" dense hide-details
                                                class="ma-0 pa-0" @change="updateCategorySelectAll(category)">
                                                <template v-slot:label>
                                                    <span class="field-label">
                                                        {{ item.label }}
                                                    </span>
                                                </template>
                                            </v-checkbox>

                                        </div>

                                    </v-col>

                                </v-row>

                            </div>

                        </div>

                    </div>

                    <v-row v-if="document_list != ''" dense class="mt-6">
                        <v-col cols="12" sm="12" md="12">
                            <v-switch color="#0F2027" v-model="field.doc_type" label="Document Uploading Status"></v-switch>
                            <span v-if="field.doc_type">
                                <span v-for="doc in document_list" :key="doc.dt_id">
                                    <v-checkbox multiple class="mr-5 d-inline-flex" dense v-model="document_type" :label="doc.dt_type"
                                        :value="doc.dt_id"></v-checkbox>
                                </span>
                            </span>
                        </v-col>
                    </v-row>

                    <v-row justify="center" class="mt-4">
                        <v-col sm="2" v-if="sel_ay_data && sel_std_data && status">
                            <v-btn class="button" color="primary" block @click="getAdmittedReport" :loading="fetch_student">
                                Fetch
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-expand-transition>

        <v-card class="box" v-if="field_list.length != 0 && student_list.length != 0" style="overflow-y: scroll">
            <v-row dense>
                <v-col cols="6" sm="1" md="1">
                    <v-btn class="ma-2" rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'AdmittedStudentProfileReport')"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>

                <v-col cols="6" sm="1" md="1">
                    <v-btn class="ma-2" rounded color="primary" outlined @click="printReport('my-table-id')">
                        <v-icon color="primary">mdi-printer</v-icon>
                        Print
                    </v-btn>
                </v-col>

                <!-- <v-col cols="6" sm="2" md="2" v-if="field.photo">
                    <v-btn class="ma-2 mr-4" tile outlined color="warning" @click="showPhotoPreview()">
                        Hide/Show Photo Preview
                    </v-btn>
                </v-col> -->

                <v-col cols="6" sm="2" md="2" v-if="field.photo">
                    <v-btn class="ma-2 mr-4" tile outlined color="blue darken-1" @click="downloadAllImages"
                        :disabled="isDownloading">
                        Download all photos
                    </v-btn>
                </v-col>
            </v-row>

            <div id="my-table-id" v-if="field_list.length != 0">
                <table dense class="elevation-1">
                    <thead>
                        <tr>
                            <th>Sr No.</th>
                            <th v-for="(hl, index) in header_list" :key="index">
                                {{ hl.text }}
                            </th>
                            <th v-if="lang_data_view">Languages Spoken At Home</th>
                            <!-- <th v-if="sibling_data_view">Sibling Details</th> -->
                            <th v-if="doc_view">Document Uploading Status</th>
                            <th v-if="td_view">Photo Preview</th>
                            <th v-if="sign_view">Signature Preview</th>
                            <th v-if="field.vaccination_details">Vaccination Attachment</th>
                            <th v-if="field.health_reports">Health Attachment</th>
                            <th v-if="field.award_details">Award Details</th>
                            <th v-if="field.activity_details">Activity Details</th>
                            <th v-if="field.payment_history">Payment History</th>
                            <!-- <th v-if="hc_view">Health Checkup Report</th> -->
                            <th v-if="sub_reg_data_view">Assigned Subjects</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(fl, index) in field_list" :key="index">
                            <td style="text-align: center; font-weight: 600">{{ index + 1 }}</td>
                            <td style="text-align: center" v-for="(hl, index1) in header_list" :key="index1">
                                <span class="regno" v-if="hl.text == 'Registration Number'">
                                   {{ fl[hl.value] }}
                                </span>
                                <span class="regno" v-else-if="hl.text == 'Admission Form No'"
                                    @click="showAdmission(fl.admission_form_id, fl.ad_yr_ay)">
                                    <u>{{ fl[hl.value] }}</u>
                                </span>

                                <span v-else-if="['guardian1_photo', 'guardian1_sign', 'guardian2_photo', 'guardian2_sign', 'father_photo', 'mother_photo'].includes(hl.value)">
                                    <img 
                                        v-if="fl[hl.value] && fl[hl.value] !== 'NA' && !fl[hl.value].includes('/nullnull')" 
                                        :src="fl[hl.value]" 
                                        width="50px" 
                                        height="50px" 
                                        style="object-fit: contain;"
                                        @error="fl[hl.value] = 'NA'"
                                    />
                                    <span v-else class="text-color">NA</span>
                                </span>
    
                                
                                <span v-else>{{ fl[hl.value] }}</span>
                                
                            </td>
                            <td v-if="lang_data_view">
                                <span v-for="(doc, ind) in fl.languages_known" :key="ind">
                                {{ doc }}
                                </span>
                            </td>
                            <!-- <td v-if="sibling_data_view">
                                <span v-for="(doc, ind) in fl.sibling_details_v2" :key="ind">
                                    <span v-if="doc.sibling1 != null">
                                        <center><b>Sibling Details 1</b></center>
                                        <b>Name : </b>
                                        {{ doc.sibling1.sibling_name }}<br />
                                        <b>Relation With Child : </b>
                                        {{ doc.sibling1.relationtype }}<br />
                                        <b>Date Of Birth : </b>
                                        {{ doc.sibling1.date_of_birth }}<br />
                                        <b>Age : </b>
                                        {{ doc.sibling1.age }}<br />
                                        <b>School Name : </b>
                                        {{ doc.sibling1.name_of_school }}<br />
                                    </span>

                                    <span v-if="doc.sibling2 != null">
                                        <center><b>Sibling Details 2</b></center>
                                        <b>Name : </b>
                                        {{ doc.sibling2.sibling_name }}<br />
                                        <b>Relation With Child : </b>
                                        {{ doc.sibling2.relationtype }}<br />
                                        <b>Date Of Birth : </b>
                                        {{ doc.sibling2.date_of_birth }}<br />
                                        <b>Age : </b>
                                        {{ doc.sibling2.age }}<br />
                                        <b>School Name : </b>
                                        {{ doc.sibling2.name_of_school }}<br />
                                    </span>
                                </span>
                            </td> -->
                            <td v-if="doc_view">
                                <span v-for="(doc, index, ind) in fl.doc_type" :key="ind">
                                    <span class="text-color" v-if="doc == 'NO'">
                                        {{ ind + 1 }}. {{ index }} : {{ doc }} <br />
                                    </span>

                                    <span v-else> {{ ind + 1 }}. {{ index }} : {{ doc }} <br /> </span>
                                </span>
                            </td>
                            <td v-if="td_view">
                                <img v-if="fl.photo != 'NA'" :src="fl.photo" width="50px" height="50px" />
                                <span v-else class="text-color">NA</span>
                            </td>
                            <td v-if="sign_view">
                                <img
                                    v-if="fl.signature && fl.signature != 'NA' && !fl.signature.includes('/nullnull')"
                                    :src="fl.signature"
                                    width="100px"
                                    height="50px"
                                    style="object-fit: contain;"
                                />
                                <span v-else class="text-color">NA</span>
                            </td>
                            <td v-if="field.vaccination_details" style="text-align: center;">
                                <v-btn v-if="fl.vaccination_attachment && fl.vaccination_attachment != 'NA'" icon
                                    color="#0f2027" @click="showVaccinationAttachmentDialog(fl)" class="screen-only">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>

                                <div v-if="fl.vaccination_attachment && fl.vaccination_attachment != 'NA'" class="print-excel-only d-none" style="text-align: left;">
                                    <span v-for="(name, idx) in (fl.vaccination_name ? fl.vaccination_name.split(',') : [])" :key="idx">
                                        {{ idx + 1 }}. <b>Name:</b> {{ name ? name.trim() : 'NA' }} | 
                                        <b>Date:</b> {{ fl.vaccination_date && fl.vaccination_date.split(',')[idx] ? fl.vaccination_date.split(',')[idx].trim() : 'NA' }} | 
                                        <b>Compliance:</b> {{ fl.vaccination_iscompliance && fl.vaccination_iscompliance.split(',')[idx] ? fl.vaccination_iscompliance.split(',')[idx].trim() : 'NA' }}<br>
                                    </span>
                                </div>

                                <span v-else class="text-color">
                                    NA
                                </span>
                            </td>
                            <td v-if="field.health_reports" style="text-align: center;">
                                <v-btn v-if="fl.doc_attachment && fl.doc_attachment.length > 0" icon color="#0f2027"
                                    @click="showHealthDocuments(fl)" class="screen-only">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>

                                <div v-if="fl.doc_attachment && fl.doc_attachment.length > 0" class="print-excel-only d-none" style="text-align: left;">
                                    <span v-for="(doc, idx) in fl.doc_attachment" :key="idx">
                                        {{ idx + 1 }}. <b>Name:</b> {{ fl.doc_name[idx] || 'NA' }} | <b>Date:</b> {{ fl.doc_date[idx] || 'NA' }} | <b>Desc:</b> {{ fl.doc_des[idx] || 'NA' }}<br>
                                    </span>
                                </div>

                                <span v-if="!fl.doc_attachment || fl.doc_attachment.length === 0" class="text-color">
                                    NA
                                </span>
                            </td>
                            <td v-if="field.award_details" style="text-align: center;">
                                <v-btn v-if="fl.doc_attachment && fl.doc_attachment.length > 0" icon color="#0f2027"
                                    @click="showAwardDocuments(fl)" class="screen-only">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>

                                <div v-if="fl.doc_attachment && fl.doc_attachment.length > 0" class="print-excel-only d-none" style="text-align: left;">
                                    <span v-for="(doc, idx) in fl.doc_attachment" :key="idx">
                                        {{ idx + 1 }}. <b>Name:</b> {{ fl.doc_name[idx] || 'NA' }} | <b>Desc:</b> {{ fl.doc_des[idx] || 'NA' }}<br>
                                    </span>
                                </div>

                                <span v-if="!fl.doc_attachment || fl.doc_attachment.length === 0" class="text-color">
                                    NA
                                </span>
                            </td>
                            <td v-if="field.activity_details" style="text-align: center;">
                                <v-btn v-if="fl.doc_name && fl.doc_name.length > 0" icon color="#0f2027"
                                    @click="showActivityDetails(fl)" class="screen-only">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>

                                <div v-if="fl.doc_name && fl.doc_name.length > 0" class="print-excel-only d-none" style="text-align: left;">
                                    <span v-for="(name, idx) in fl.doc_name" :key="idx">
                                        {{ idx + 1 }}. <b>Name:</b> {{ fl.doc_name[idx] || 'NA' }} | 
                                        <b>Role:</b> {{ fl.doc_role[idx] || 'NA' }} | 
                                        <b>Level:</b> {{ fl.doc_level[idx] || 'NA' }} | 
                                        <b>Desc:</b> {{ fl.doc_des[idx] || 'NA' }}<br>
                                    </span>
                                </div>

                                <span v-if="!fl.doc_name || fl.doc_name.length === 0" class="text-color">
                                    NA
                                </span>
                            </td>
                            <td v-if="field.payment_history" style="text-align: center;">
                                <v-btn v-if="fl.payment_history && fl.payment_history.length > 0" icon color="#0f2027"
                                    @click="showPaymentDetails(fl)" class="screen-only">
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>

                                <div v-if="fl.payment_history && fl.payment_history.length > 0" class="print-excel-only d-none" style="text-align: left;">
                                    <div v-for="(pay, idx) in fl.payment_history" :key="idx" style="page-break-inside: avoid; margin-bottom: 6px;">
                                        {{ idx + 1 }}. <b>Paid For:</b> {{ pay.purpose || 'NA' }} | 
                                        <b>Amount:</b> {{ pay.amount || 'NA' }} | 
                                        <b>Date:</b> {{ pay.transaction_date || 'NA' }} | 
                                        <b>Status:</b> {{ pay.paymenttransactionstatus || 'NA' }} | 
                                        <b>Mode:</b> {{ pay.mode || 'NA' }}
                                    </div>
                                </div>

                                <span v-if="!fl.payment_history || fl.payment_history.length === 0" class="text-color">
                                    NA
                                </span>
                            </td>
                            <!-- <td v-if="hc_view">
                                <span v-if="fl.health_data === 'YES'">
                                    <span v-for="(file, index) in fl.health_checkup_files" :key="index">
                                        <a :href="basepath + file.health_checkup_file_path + file.health_checkup_file_name"
                                            target="_blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon color="#0f2027" v-bind="attrs" v-on="on">
                                                        <v-icon>mdi-eye</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Health Checkup Report {{ fl.health_checkup_files.length > 1 ?
                                                    (index + 1)
                                                    : '' }}</span>
                                            </v-tooltip>
                                        </a>
                                    </span>
                                </span>
                                <span class="text-color" v-if="fl.health_data == 'NO'">
                                    <strong>Report Not Uploaded</strong>
                                </span>
                            </td> -->
                            <td v-if="sub_reg_data_view" style="vertical-align: top; padding: 10px;">
                                <div v-if="fl.subject_registration_details && fl.subject_registration_details.length > 0">
                                    
                                    <div style="font-weight: bold; margin-bottom: 5px; text-align: left;">
                                        Total: {{ fl.subject_registration_details.length }} Subjects
                                    </div>
                                    
                                    <div class="scrollable-list" style="word-wrap: break-word; white-space: normal; line-height: 1.5;">
                                        {{ 
                                            fl.subject_registration_details.map(sub => 
                                                sub.course_rule ? `${sub.course_name} (${sub.course_rule})` : sub.course_name
                                            ).join(', ') 
                                        }}
                                    </div>

                                </div>
                                <span v-else style="color: red; font-weight: bold; display: block; text-align: center;">
                                    Not Registered
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td style="font-weight: bold; text-align: right">Total Count: {{ field_list.length }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <th>Sr.No.</th>
                        <th v-for="(hl, index) in header_list" :key="index">{{ hl.text }}</th>
                        <th v-if="doc_view">Document Uploading Status</th>
                        <th v-if="td_view">Photo Preview</th>
                        <th v-if="sign_view">Signature Preview</th>
                        <th v-if="field.vaccination_details">Vaccination Attachment</th>
                        <th v-if="field.health_reports">Health Attachment</th>
                        <th v-if="field.award_details">Award Details</th>
                        <th v-if="field.activity_details">Activity Details</th>
                        <th v-if="field.payment_history">Payment History</th>
                        <!-- <th v-if="hc_view">Health Checkup Report</th> -->
                        <th v-if="sub_reg_data_view">Assigned Subjects</th>
                    </tfoot>
                </table>
            </div>
        </v-card>


        <v-dialog v-model="dialog" persistent max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title><strong>Registered Courses</strong></v-toolbar-title>
                </v-toolbar>

                <v-col cols="12">
                    <v-card class="box">
                        <span v-if="crs_list != ''">
                            <v-data-table dense :headers="headers" :items="crs_list" :search="search"
                                class="elevation-1 mytable" :items-per-page="-1">
                                <template v-slot:body="{ items }">
                                    <tbody>
                                        <tr v-for="(item, index) in items" :key="item.courseOfferingLearner">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ item.crs_name }}</td>
                                            <td class="text-center">{{ item.crs_type }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-data-table>
                        </span>

                        <v-row justify="center">
                            <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <!-- Health Reports Dialog -->
        <v-dialog v-model="health_dialog" persistent max-width="800px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title><strong>Health Reports Details</strong></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="health_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pt-4">
                    <v-data-table 
                        dense 
                        :headers="health_report_headers" 
                        :items="selected_health_reports"
                        class="elevation-1 mytable" 
                        hide-default-footer
                        :items-per-page="-1"
                    >
                        <template v-slot:item.attachment="{ item }">
                            <v-btn icon color="#0f2027" :href="item.attachment" target="_blank">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions class="justify-center pb-4">
                    <v-btn rounded class="button" @click="health_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Vaccination Details Dialog -->
        <v-dialog v-model="vaccination_dialog" persistent max-width="800px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title><strong>Vaccination Details</strong></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="vaccination_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pt-4">
                    <v-data-table 
                        dense 
                        :headers="vaccination_headers" 
                        :items="selected_vaccinations"
                        class="elevation-1 mytable" 
                        hide-default-footer
                        :items-per-page="-1"
                    >
                        <template v-slot:item.attachment="{ item }">
                            <v-btn icon color="#0f2027" :href="item.attachment" target="_blank" v-if="item.attachment && item.attachment !== 'NA'">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <span v-else class="text-color">NA</span>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions class="justify-center pb-4">
                    <v-btn rounded class="button" @click="vaccination_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="award_dialog" persistent max-width="800px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title><strong>Awards Details</strong></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="award_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pt-4">
                    <v-data-table 
                        dense 
                        :headers="award_headers" 
                        :items="selected_awards"
                        class="elevation-1 mytable" 
                        hide-default-footer
                        :items-per-page="-1"
                    >
                        <template v-slot:item.attachment="{ item }">
                            <v-btn icon color="#0f2027" :href="item.attachment" target="_blank" v-if="item.attachment && item.attachment !== 'NA'">
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <span v-else class="text-color">NA</span>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-card-actions class="justify-center pb-4">
                    <v-btn rounded class="button" @click="award_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="activity_dialog" persistent max-width="800px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title><strong>Activity Details</strong></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="activity_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pt-4">
                    <v-data-table 
                        dense 
                        :headers="activity_headers" 
                        :items="selected_activities"
                        class="elevation-1 mytable" 
                        hide-default-footer
                        :items-per-page="-1"
                    >
                    </v-data-table>
                </v-card-text>

                <v-card-actions class="justify-center pb-4">
                    <v-btn rounded class="button" @click="activity_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

         <v-dialog v-model="payment_dialog" persistent max-width="800px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title><strong>Payment History</strong></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="payment_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pt-4">
                    <v-data-table 
                        dense 
                        :headers="payment_headers" 
                        :items="selected_payment_details"
                        class="elevation-1 mytable" 
                        hide-default-footer
                        :items-per-page="-1"
                    >
                    </v-data-table>
                </v-card-text>

                <v-card-actions class="justify-center pb-4">
                    <v-btn rounded class="button" @click="payment_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; 

export default {
    data: () => ({
        fieldCategories: [
            {
                title: "Basic Details",
                selectAll: false,
                icon: "mdi-account",
                fields: [
                    // { model: "registration_number", label: "Registration Number" },
                    { model: "srn_no", label: "SRN" },
                    { model: "pen_no", label: "PEN" },
                    { model: "saral_id", label: "Saral Id" },
                    { model: "standard", label: "Standard" },
                    { model: "division", label: "Division" },
                    { model: "rollno", label: "Roll No." },
                    { model: "grno", label: "GR Number" },
                    { model: "firstname", label: "First Name" },
                    { model: "middlename", label: "Middle Name" },
                    { model: "lastname", label: "Last Name" },
                    { model: "name_adhar", label: "Name as per Aadhar" },
                    { model: "parent_name", label: "Parent Name" },
                    { model: "parent_contact_no", label: "Parent Contact No" },
                    { model: "issingleparent", label: "Is Single Parent" },
                    { model: "languages_known", label: "Languages spoken at home" },
                    { model: "apaar_id", label: "Apaar ID" },
                    { model: "fullname", label: "Student Full Name" },
                    { model: "unicode_student_name", label: "Unicode Student Full Name" },
                    { model: "gender", label: "Gender" },
                    { model: "date_of_birth", label: "Date Of Birth" },
                    { model: "birth_place", label: "Birth Place" },
                    { model: "unicode_birth_place", label: "Unicode Birth Place" },
                    { model: "date_of_birth_in_words", label: "Date of Birth in Words" },
                    { model: "birth_address", label: "Birth Address" },
                    { model: "father_name_as_per_doc", label: "Father Name as per Document" },
                    { model: "mother_name_as_per_doc", label: "Mother Name as per Document" },
                    { model: "bloodgroup", label: "Blood Group" },
                    { model: "aadhar_no", label: "Aadhar No" },
                    { model: "mothertoungue", label: "Mother Tongue" },
                    { model: "birthcountry", label: "Birth Country" },
                    { model: "birth_district", label: "Birth District" },
                    { model: "birth_taluka", label: "Birth Taluka" },
                    { model: "unicode_birth_taluka", label: "Unicode Birth Taluka" },
                    { model: "birth_state", label: "Birth State" },
                    { model: "family_income", label: "Family Income" },
                    { model: "familytype", label: "Family Type" },
                    { model: "citizenship", label: "Citizenship" },
                    { model: "nationality", label: "Nationality" },
                    { model: "identification_mark_on_body", label: "Identification Mark" },
                    { model: "hemoglobin", label: "Hemoglobin Level" },
                ]
            },
            {
                title: "Guardian & Contact Details",
                selectAll: false,
                icon: "mdi-account-multiple-outline",
                fields: [
                    { model: "primary_contact_number", label: "Primary Contact Number" },
                    { model: "father_contact_number", label: "Father Contact Number" },
                    { model: "personal_email", label: "Primary Email" },
                    { model: "stud_father_email", label: "Father Email" },
                    { model: "mother_contact_number", label: "Mother Contact Number" },
                    { model: "stud_mother_email", label: "Mother Email" },
                    { model: "parent_primary_no", label: "Parent Primary Contact Number" },
                    { model: "parent_primary_email", label: "Parent Primary Email" },
                    { model: "stud_emergency_contact_name", label: "Emergency Contact Name" },
                    { model: "stud_emergency_contact_number", label: "Emergency Contact Number" },
                    { model: "stud_emergency_contact_address", label: "Emergency Contact Address" },
                    { model: "stud_emergency_relation", label: "Emergency Relation" },
                    { model: "guardian1_name", label: "Guardian1 Name" },
                    { model: "guardian1_contact", label: "Guardian1 Contact" },
                    { model: "guardian_email", label: "Guardian1 Email" },
                    { model: "guardian1_aadhar", label: "Guardian1 Aadhar No" },
                    { model: "guardian_address", label: "Guardian1 Address" },
                    { model: "guardian_relation", label: "Guardian1 Relation" },
                    { model: "guardian1_occupation", label: "Guardian1 Relation" },
                    { model: "guardian1_office", label: "Guardian1 Office Name" },
                    { model: "guardian1_office_no", label: "Guardian1 Office No" },
                    { model: "guardian1_photo", label: "Guardian1 Photo" },
                    { model: "guardian1_sign", label: "Guardian1 Signature" },
                    { model: "guardian2_name", label: "Guardian2 Name" },
                    { model: "guardian2_contact", label: "Guardian2 Contact" },
                    { model: "guardian2_email", label: "Guardian2 Email" },
                    { model: "guardian2_aadhar", label: "Guardian2 Aadhar No" },
                    { model: "guardian2_address", label: "Guardian2 Address" },
                    { model: "guardian2_relation", label: "Guardian2 Relation" },
                    { model: "guardian2_occupation", label: "Guardian2 Relation" },
                    { model: "guardian2_office", label: "Guardian2 Office Name" },
                    { model: "guardian2_office_no", label: "Guardian2 Office No" },
                    { model: "guardian2_photo", label: "Guardian2 Photo" },
                    { model: "guardian2_sign", label: "Guardian2 Signature" },
                ]
            },
            {
                title: "Address Details",
                selectAll: false,
                icon:"mdi-home-map-marker",
                fields: [
                    { model: "laddress", label: "Local Address" },
                    { model: "unicode_laddress", label: "Unicode Local Address" },
                    { model: "lcountry", label: "Local Country" },
                    { model: "lstate", label: "Local State" },
                    { model: "lcity", label: "Local City" },
                    { model: "ldistrict", label: "Local District" },
                    { model: "ltaluka", label: "Local Taluka" },
                    { model: "lpin", label: "Local Pincode" },
                    { model: "paddress", label: "Permanent Address" },
                    { model: "unicode_paddress", label: "Unicode Permanent Address" },
                    { model: "pcountry", label: "Permanent Country" },
                    { model: "pstate", label: "Permanent State" },
                    { model: "pcity", label: "Permanent City" },
                    { model: "pdistrict", label: "Permanent District" },
                    { model: "ptaluka", label: "Permanent Taluka" },
                    { model: "ppin", label: "Permanent Pincode" }
                ]
            },
            {
                title: "Parent/Relatives Details",
                selectAll: false,
                icon:"mdi-human-male-female-child",
                fields: [
                    { model: "mother_first_name", label: "Mother First Name" },
                    { model: "mother_middle_name", label: "Mother Middle Name" },
                    { model: "mother_last_name", label: "Mother last Name" },
                    { model: "mother_full_name", label: "Mother Full Name" },
                    { model: "unicode_mother_name", label: "Unicode Mother Name" },
                    { model: "mother_education", label: "Mother Education" },
                    { model: "mother_income", label: "Mother Annual Income" },
                    { model: "mother_email_relative", label: "Mother Email (Relative)" },
                    { model: "mother_organization_name", label: "Mother Organization" },
                    { model: "mother_department", label: "Mother Department" },
                    { model: "mother_designation", label: "Mother Designation" },
                    { model: "mother_office_address", label: "Mother Office Address" },
                    { model: "mother_contact_no_relative", label: "Mother Contact (Relative)" },
                    { model: "mother_occupation", label: "Mother Occupation" },
                    { model: "mother_aadharno", label: "Mother Aadhar No" },
                    { model: "mother_dob", label: "Mother DOB" },
                    { model: "mother_photo", label: "Mother Photo" },
                    { model: "father_full_name", label: "Father First Name" },
                    { model: "father_middle_name", label: "Father Middle Name" },
                    { model: "father_last_name", label: "Father last Name" },
                    { model: "father_fullname", label: "Father Full Name" },
                    { model: "unicode_father_name", label: "Unicode Father Name" },
                    { model: "father_education", label: "Father Education" },
                    { model: "father_income", label: "Father Annual Income" },
                    { model: "father_email_relative", label: "Father Email (Relative)" },
                    { model: "father_organization_name", label: "Father Organization" },
                    { model: "father_department", label: "Father Department" },
                    { model: "father_designation", label: "Father Designation" },
                    { model: "father_office_address", label: "Father Office Address" },
                    { model: "father_contact_no_relative", label: "Father Contact (Relative)" },
                    { model: "father_occupation", label: "Father Occupation" },
                    { model: "father_aadharno", label: "Father Aadhar No" },
                    { model: "father_dob", label: "Father DOB" },
                    { model: "father_photo", label: "Father Photo" },
                    { model: "sibling_details_v2", label: "Sibling Details" }
                ]
            },
            {
                title: "Caste Information",
                selectAll: false,
                icon:"mdi-view-grid-outline",
                fields: [
                    { model: "quota", label: "Quota" },
                    { model: "religion", label: "Religion" },
                    { model: "cast", label: "Caste" },
                    { model: "sub_cast", label: "Sub Caste" },
                    { model: "actual_category", label: "Actual Category" },
                    { model: "domacile", label: "Domicile" },
                    { model: "category", label: "Admitted Category" },
                    { model: "current_ay_quota", label: "Current AY Quota" }
                ]
            },
            {
                title: "Photo & Signature",
                selectAll: false,
                icon:"mdi-camera",
                fields: [
                    { model: "photo", label: "Student Photo" },
                    { model: "signature", label: "Student Signature" }
                ]
            },
            {
                title: "Previous School Information",
                selectAll: false,
                icon:"mdi-school",
                fields: [
                    { model: "admissionyear", label: "Admission Year" },
                    { model: "admission_date", label: "Date of Admission" },
                    { model: "physical_date", label: "Date of Physically Attended" },
                    { model: "unicode_physical_date", label: "Unicode Physical Date" },
                    { model: "previousschoolpassingstandard_id", label: "Previous School Passing Standard" },
                    { model: "previous_school_name", label: "Previous School Name" },
                    { model: "unicode_previous_school_name", label: "Unicode Previous School Name" },
                    { model: "reason_for_leaving_last_school", label: "Previous School Leaving Reason" },
                    { model: "previous_school_obtained_percentage", label: "Previous School Obtained Percentage" },
                    { model: "admittedstandard_id", label: "Admitted Standard" },
                    { model: "currentstandard_id", label: "Current Standard" },
                    { model: "house_id", label: "House" },
                    { model: "school_medium", label: "School Medium" },
                    { model: "is_admitted_for_term1", label: "Is Admitted For Term 1" },
                ]
            },
            {
                title: "Health & Medical Details",
                selectAll: false,
                icon:"mdi-medical-bag",
                fields: [
                    { model: "health_data", label: "Health Data" },
                    { model: "allergy", label: "Allergy" },
                    { model: "medical_condition", label: "Medical Condition" },
                    { model: "height", label: "Height" },
                    { model: "weight", label: "Weight" },
                    { model: "past_medical_info", label: "Past Medical Surgery Emergency" },
                    { model: "family_doc_name", label: "Family Doctor Name" },
                    { model: "family_doc_contact", label: "Family Doctor Contact" },
                    { model: "emg_hospital_name", label: "Emergency Hospital Name" },
                    { model: "emg_hospital_contact", label: "Emergency Hospital Number" },
                    { model: "emg_hospital_address", label: "Emergency Hospital Address" },
                    { model: "vaccination_details", label: "Vaccination Details" },
                    { model: "health_reports", label: "Health Reports" },
                ]
            },
             {
                title: "Transport Details",
                selectAll: false,
                icon:"mdi-bus",
                fields: [
                    { model: "transportaion_mode", label: "Transportation Mode" },
                    { model: "driver_name", label: "Driver Name" },
                    { model: "driver_aadhar_no", label: "Driver Aadhaar No" },
                    { model: "driver_mobile_no", label: "Driver Mobile No" },
                    { model: "driver_address", label: "Driver Address" },
                    { model: "vehicle_no", label: "Vehicle No" },
                    // { model: "pick_up_time", label: "Transport Pick Up Time" },
                    // { model: "drop_time", label: "Transport Drop Time" },
                ]
            },
            {
                title: "Awards/Achievment & Activity Details",
                selectAll: false,
                icon:"mdi-trophy-variant",
                fields: [
                    { model: "award_details", label: "Awards/Achievment" },
                    { model: "activity_details", label: "Student Activity" }
                ]
            },
            {
                title: "Skills & Interests",
                selectAll: false,
                icon:"mdi-head-lightbulb",
                fields: [
                    { model: "skills", label: "Skills" },
                    { model: "interests", label: "Interests" }
                ]
            },
            {
                title: "Current Subject Details",
                selectAll: false,
                icon:"mdi-bookshelf",
                fields: [
                    { model: "subject_registration_details", label: "Assigned Subjects" }
                ]
            },
            {
                title: "Payment Details",
                selectAll: false,
                icon:"mdi-account-cash",
                fields: [
                    { model: "payment_history", label: "Payment History" },
                ]
            }
        ],
        health_dialog: false,
        selected_health_reports: [],
        health_report_headers: [
            { text: "Upload Date", value: "date", sortable: true },
            { text: "Document Name", value: "name", sortable: true },
            { text: "Description", value: "description", sortable: true },
            { text: "View Attachment", value: "attachment", align: "center", sortable: false }
        ],
        vaccination_dialog: false,
        selected_vaccinations: [],
        vaccination_headers: [
            { text: "Vaccination Name", value: "name", sortable: true },
            { text: "Date", value: "date", sortable: true },
            { text: "Compliance", value: "compliance", sortable: true },
            { text: "View Attachment", value: "attachment", align: "center", sortable: false }
        ],
        award_dialog: false,
        selected_awards: [],
        award_headers: [
            { text: "Award Name", value: "name", sortable: true },
            { text: "Description", value: "description", sortable: true },
            { text: "View Attachment", value: "attachment", align: "center", sortable: false }
        ],
        activity_dialog: false,
        selected_activities: [],
        activity_headers: [
            { text: "Activity Name", value: "name", sortable: true },
            { text: "Role", value: "role", sortable: true },
            { text: "Level", value: "level", sortable: true },
            { text: "Description", value: "description", sortable: true },
        ],
        payment_dialog: false,
        selected_payment_details: [],
        payment_headers: [
            { text: "Paid For", value: "purpose", sortable: true },
            { text: "Amount", value: "amount", sortable: true },
            { text: "Transaction Date", value: "transaction_date", sortable: true },
            { text: "Payment Status", value: "paymenttransactionstatus", sortable: true },
            { text: "Payment Mode", value: "mode", sortable: true },
        ],
        stud_data: [],
        dialog: false,
        show_stud_data_dialog: false,
        show_admission_form: false,
        overlay: false,
        search: "",
        ay_std_data: null,
        fetch_btn_load: false,
        fetch_student:false,
        current_academic_year: "",
        std: "",
        status: "",
        quota: "",
        isDownloading: false,
        stopDownloading: false,

        selected_student: null,
        all_toggle: false,

        field: {
            //basic
            registration_number: true, 
            srn_no: false, 
            pen_no: false, 
            saral_id: false, 
            standard: false, 
            division: false, 
            rollno: false,
            grno: false, 
            firstname: false, 
            middlename: false, 
            lastname: false, 
            name_adhar: false, 
            parent_name: false,
            parent_contact_no: false, 
            issingleparent: false, 
            languages_known: false, 
            apaar_id: false, 
            fullname: false, 
            father_full_name: false,
            mother_first_name: false, 
            unicode_student_name: false, 
            unicode_father_name: false, 
            unicode_mother_name: false, 
            gender: false,
            date_of_birth: false, 
            birth_place: false, 
            unicode_birth_place: false, 
            date_of_birth_in_words: false, 
            birth_address: false,
            father_name_as_per_doc: false, 
            mother_name_as_per_doc: false, 
            bloodgroup: false, 
            aadhar_no: false, 
            mothertoungue: false, 
            birthcountry: false, 
            birth_district: false, 
            birth_taluka: false, 
            unicode_birth_taluka: false,
            birth_state: false, 
            family_income: false, 
            familytype: false, 
            citizenship: false, 
            nationality: false, 
            identification_mark_on_body: false, 
            allergy: false, 
            medical_condition: false, 
            hemoglobin: false, 
            isvaccination: false,

            // Contact
            primary_contact_number: false, 
            father_contact_number: false, 
            personal_email: false, 
            stud_father_email: false,
            mother_contact_number: false, 
            stud_mother_email: false,
            parent_primary_no: false,
            parent_primary_email: false, 
            stud_emergency_contact_name: false, 
            stud_emergency_contact_number: false, 
            stud_emergency_contact_address: false, 
            stud_emergency_relation: false, 
            guardian1_name: false, 
            guardian1_contact: false, 
            guardian_address: false, 
            guardian_email: false, 
            guardian1_aadhar:false,
            guardian_relation: false,
            guardian1_occupation:false,
            guardian1_office:false,
            guardian1_office_no:false,
            guardian1_photo:false,
            guardian1_sign:false,
            guardian2_name: false, 
            guardian2_contact: false,
            guardian2_address: false, 
            guardian2_email: false, 
            guardian2_aadhar:false,
            guardian2_relation: false,
            guardian2_occupation:false,
            guardian2_office:false,
            guardian2_office_no:false,
            guardian2_photo:false,
            guardian2_sign:false,

            // Address
            laddress: false,
            unicode_laddress: false,
            lcountry: false,
            lstate: false, 
            lcity: false, 
            ldistrict: false,
            ltaluka: false,
            lpin: false,
            paddress: false,
            unicode_paddress: false, 
            pcountry: false, 
            pstate: false, 
            pcity: false, 
            pdistrict: false, 
            ptaluka: false, 
            ppin: false,
            // Relatives
            mother_full_name: false, 
            mother_education: false, 
            mother_income: false, 
            mother_email_relative: false, 
            mother_organization_name: false, 
            mother_department: false, 
            mother_designation: false, 
            mother_office_address: false,
            mother_contact_no_relative: false,
            mother_occupation: false, 
            mother_aadharno: false, 
            mother_dob: false, 
            mother_middle_name:false,
            mother_last_name:false,
            mother_photo:false,
            father_fullname: false, 
            father_middle_name:false,
            father_last_name:false,
            father_photo:false,
            father_education: false, 
            father_income: false, 
            father_email_relative: false, 
            father_organization_name: false, 
            father_department: false, 
            father_designation: false, 
            father_office_address: false, 
            father_contact_no_relative: false, 
            father_occupation: false, 
            father_aadharno: false,
            father_dob: false, 
            sibling_details_v2: false,
            // Caste
            quota: false, 
            religion: false, 
            cast: false, 
            sub_cast: false, 
            actual_category: false, 
            domacile: false, 
            category: false, 
            current_ay_quota: false,
            // Photo
            photo: false, signature: false,
            // Other Info
            admissionyear: false, 
            admission_date: false, 
            physical_date: false, 
            unicode_physical_date: false, 
            previousschoolpassingstandard_id: false, 
            previous_school_name: false, 
            unicode_previous_school_name: false,
            reason_for_leaving_last_school: false, 
            previous_school_obtained_percentage: false, 
            admittedstandard_id: false, 
            currentstandard_id: false, 
            house_id: false, 
            school_medium: false, 
            is_admitted_for_term_1: false, 
            driver_name: false, 
            driver_aadhar_no: false, 
            driver_mobile_no: false, 
            transportaion_mode: false, 
            driver_address: false,
            // Miscellaneous / Docs
            doc_type: false, 
            payment_history: false, 
            health_data: false, 
            difficulty_in_hearing: false,
            difficulty_in_vision: false, 
            difficulty_in_speech: false,
            difficulty_in_learning: false,
            difficulty_in_motor: false,
            immunization: false,
            past_medical_surgery_emergency: false, 
            awards: false, 
            subject_registration_details: false,
            vaccination_details: false,
            is_admitted_for_term1:false,
            health_reports:false,
            award_details:false,
            activity_details:false,
            weight:false,
            height:false,
            past_medical_info:false,
            family_doc_name:false,
            family_doc_contact:false,
            emg_hospital_name:false,
            emg_hospital_contact:false,
            emg_hospital_address:false,
            vehicle_no:false,
            skills:false,
            interests:false,

        },
        td_view: false,
        sign_view:false,
        hc_view: false,
        doc_view: false,
        father_data_view: false,
        mother_data_view: false,
        sibling_data_view: false,
        guardian_data_view: false,
        lang_data_view: false,
        sub_reg_data_view: false,

        header_list: [],
        field_list: [],
        xls_header: [],
        ay_std_div_list: null,
        sel_ay_data: null,
        std_div_list: null,
        sel_std_data: null,
        div_list: null,
        status_list: [],
        snackbar: false,
        snackbar_msg: "",
        color: "",
        awspath: null,
        basepath: null,
        document_list: [],
        document_type: [],
        quota_list: [],
        crs_list: [],
        person_details: null,
        tenant: null,
        student_list:[],
        headers: [
            {
                text: "Sr. No.",
                sortable: false,
                value: "srno1",
            },
            {
                text: "Subject",
                align: "center",
                sortable: false,
                value: "crs_name",
            },
            {
                text: "Subject Type",
                align: "center",
                sortable: false,
                value: "crs_type",
            },
        ],
    }),
    methods: {
       getcourse(subjects) {
            this.crs_list = (subjects || []).map((subject, index) => ({
                courseOfferingLearner: index,
                crs_name: subject.course_name || "-",
                crs_type: subject.course_rule || "-"
            }));

            this.dialog = true;
        },
        toggleAllFields(val) {
            const keys = Object.keys(this.field);

            keys.forEach(key => {
                this.field[key] = val;
            });

            this.fieldCategories.forEach(category => {
                category.selectAll = val;
            });
        },
        fnExcelReport(id, name) {
            let wrapper = document.getElementById(id);
            let originalTable = wrapper.tagName.toLowerCase() === 'table' ? wrapper : wrapper.querySelector('table');

            if (!originalTable) {
                console.error("Table not found!");
                return;
            }

            let csvArray = [];
            let rows = originalTable.querySelectorAll('tr');
            
            for (let i = 0; i < rows.length; i++) {
                let rowData = [];
                let cols = rows[i].querySelectorAll('td, th');
                
                for (let j = 0; j < cols.length; j++) {
                    let cell = cols[j].cloneNode(true);
                    
                    let elementsToRemove = cell.querySelectorAll('.screen-only, button, input');
                    elementsToRemove.forEach(el => el.remove());

                    let hiddenData = cell.querySelectorAll('.print-excel-only');
                    hiddenData.forEach(el => el.classList.remove('d-none'));

                    let brs = cell.querySelectorAll('br');
                    brs.forEach(br => br.replaceWith('\n'));
                    
                    let text = cell.textContent.trim().replace(/"/g, '""');
                    
                    rowData.push(`"${text}"`);
                }
                
                csvArray.push(rowData.join(','));
            }

            let csvString = csvArray.join('\n');
            let fileName = name + "_" + parseInt(Math.random() * 100000000) + ".csv"; 
            
            let blob = new Blob(['\uFEFF' + csvString], { type: 'text/csv;charset=utf-8;' });
            
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName); 
            } else {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        },
       printReport(id) {
            const wrapper = document.getElementById(id);
            const clone = wrapper.cloneNode(true);
            const screenOnly = clone.querySelectorAll('.screen-only, .v-btn');
            screenOnly.forEach(el => el.remove());

            const printOnly = clone.querySelectorAll('.print-excel-only');
            printOnly.forEach(el => {
                el.classList.remove('d-none');
                el.style.display = 'block';
            });

            const printContents = clone.innerHTML;
            const printWindow = window.open("", "_blank");
            
            printWindow.document.write(`
                    <html>
                    <head>
                        <title>Admitted Student Profile Report</title>
                        <style>
                            @page { 
                                size: landscape; 
                                margin: 10mm; 
                            }
                            body { font-family: Arial, sans-serif; margin: 20px; font-size: 12px; }
                            table { width: 100%; border-collapse: collapse; page-break-before: avoid; }
                            table, th, td { border: 1px solid #000; }
                            th, td { padding: 5px; text-align: left; word-break: break-word; }
                            th { background: #f0f0f0; }
                            img { width: 50px; height: 50px; }
                            h2 { margin-bottom: 10px; page-break-after: avoid; break-after: avoid; }
                            
                            @media print {
                                body { margin: 10mm; padding: 0; }
                                h2 { page-break-after: avoid !important; break-after: avoid !important; }
                                
                                /* This forces rows to break naturally across pages! */
                                table, tr, td, th { 
                                    page-break-inside: auto !important; 
                                    break-inside: auto !important; 
                                }
                                
                                thead { display: table-header-group; }
                                tfoot { display: none; }
                            }
                        </style>
                    </head>
                    <body>
                        <h2 style="text-align:center; page-break-after: avoid;">Admitted Student Profile Report</h2>
                        ${printContents}
                    </body>
                    </html>
                `);

            printWindow.document.close();
            printWindow.focus();

            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        },
        showPhotoPreview() {
            if (this.td_view) {
                this.td_view = false;
            } else {
                this.td_view = true;
            }
        },
        getFileExtension(url) {
            if (url) {
                return url.split(".").pop().split(/\#|\?/)[0];
            } else {
                console.error("URL is undefined");
                return "";
            }
        },

        async downloadAllImages() {
            this.isDownloading = true;
            this.showSnackbar("success", "Photos are downloading, please wait... ");
            const formData = {
                learner: this.field_list.map((item) => item.learnerId),
            };
            try {
                axios
                    .post("/admissionReport/renderLearnerPhotoZip", formData, {
                        responseType: "blob",
                    })
                    .then((res) => {
                        const blob = new Blob([res.data], { type: "application/zip" });
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "Learner_Photos.zip";
                        link.click();
                    });
            } catch (error) {
                this.showSnackbar("error", "Something went wrong...");
            } finally {
            }
        },

        async downloadImg(imageSrc, reg_number) {
            if (!imageSrc) {
                console.error("Image source is undefined or empty");
                return;
            }

            const downloadFilename = reg_number;
            const proxyUrl = "https://api.allorigins.win/get?url=";
            const imageUrl = proxyUrl + encodeURIComponent(imageSrc);
            const extension = this.getFileExtension(imageSrc);
            const supportedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];

            if (!supportedExtensions.includes(extension.toLowerCase())) {
                console.error("Unsupported file extension:", extension);
                return;
            }

            const fullDownloadFilename = `${downloadFilename}.${extension}`;

            try {
                const response = await fetch(imageUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                const blobResponse = await fetch(data.contents);
                const blob = await blobResponse.blob();

                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fullDownloadFilename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error("Error downloading the image:", error);
            }
        },
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        stopDownloads() {
            this.stopDownloading = true;
        },
        async showAdmission(form_no, ay) {
            if (form_no == "NA") {
                this.showSnackbar("error", "Invalid form no!!!");
                return;
            }
            let ay_id;
            if (this.sel_ay_data.ay_id) {
                ay_id = this.sel_ay_data.ay_id;
            } else if (this.sel_ay_data.id) {
                ay_id = this.sel_ay_data.id;
            }
            localStorage.setItem("setay", ay_id);
            localStorage.setItem("setform_id", form_no);
            localStorage.setItem("admission-ay", ay_id);
            this.show_admission_form = false;
            const formData = {
                ay: ay_id,
                form_id: form_no,
            };

            try {
                const res = await axios.post("/Admission/get_application_form", formData);
                if (res.data.status.code == "SUCCESS") {
                    this.person_details = res.data.person_details;
                    console.log(this.person_details);
                    this.show_admission_form = true;
                } else {
                    this.showSnackbar("error", "Can't show form!!!");
                    this.person_details = null;
                }
            } catch (error) {
                this.showSnackbar("error", "Something went wrong...");
            } finally {
            }
        },
        showDetails(registration_number) {
            const formData = {
                ay: this.sel_ay_data.ay_id,
                learner: registration_number,
            };
            axios
                .post("/admissionReport/getLearnerDetails", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.stud_data = res.data.stud_data;
                        this.show_stud_data_dialog = true;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong...");
                })
                .finally(() => {
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        check_values() {
            if (this.sel_std_data == null) {
                this.showSnackbar("#b71c1c", "Please select Academic Year then proceed further!");
            }
            this.getStudentList();
        },
        getStd() {
            this.std_div_list = ["All"];
            this.sel_std_data = "All";
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
            this.std_div_list.unshift("All");
        },
        getDiv() {
            this.div_list = ["All"];
            this.div = "All";
            this.div_list = this.sel_std_data.div_list;
            this.div_list.unshift("All");
            this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        getAdmittedReport() {
            if (this.isDownloading) {
                this.stopDownloads();
                this.isDownloading = false;
            }
            if (this.field.photo == true) {
                this.td_view = true;
            } else {
                this.td_view = false;
            }
            if (this.field.signature == true) {
                this.sign_view = true;
            } else {
                this.sign_view = false;
            }
            if (this.field.health_data == true) {
                this.hc_view = true;
            } else {
                this.hc_view = false;
            }
            if (this.field.doc_type == true) {
                this.doc_view = true;
            } else {
                this.doc_view = false;
            }
            if (this.field.father_details == true) {
                this.father_data_view = true;
            } else {
                this.father_data_view = false;
            }
            if (this.field.sibling_details_v2 == true) {
                this.sibling_data_view = true;
            } else {
                this.sibling_data_view = false;
            }
            if (this.field.guardian_details == true) {
                this.guardian_data_view = true;
            } else {
                this.guardian_data_view = false;
            }
            if (this.field.mother_details == true) {
                this.mother_data_view = true;
            } else {
                this.mother_data_view = false;
            }
            if (this.field.languages_known == true) {
                this.lang_data_view = true;
            } else {
                this.lang_data_view = false;
            }
            if (this.field.subject_registration_details == true) {
                this.sub_reg_data_view = true;
            } else {
                this.sub_reg_data_view = false;
            }

            this.field_list = [];
            this.fetch_student = true;

            let div;
            if (this.div != null) {
                div = this.div.div_off_id;
                if (this.div.div_off_id) {
                    div = this.div.div_off_id;
                } else {
                    div = this.div;
                }
            }
            let ay;
            if (this.sel_ay_data.ay_id) {
                ay = this.sel_ay_data.ay_id;
            } else if (this.sel_ay_data.id) {
                ay = this.sel_ay_data.id;
            }
            
            // Attach selected student
            let student_id = "All";
            if (this.selected_student && this.selected_student.id && this.selected_student.id !== "All") {
                student_id = this.selected_student.id;
            }

            let data = {
                current_academic_year_id: ay,
                standard_obj: this.sel_std_data,
                division_off_id: div,
                status: this.status,
                field: this.field,
                document_type: this.document_type,
                quota: this.quota,
                student_id: student_id
            };
            axios
                .post("/admissionReport/getAdmittedStudProfileReport", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.field_list = res.data.field_list;
                        this.header_list = res.data.header_list;
                        this.xls_header = res.data.xls_header;
                    } else {
                        //error
                    }
                    this.fetch_student = false;
                })
                .catch((error) => {
                    window.console.log(error);
                    this.fetch_student = false;
                })
                .finally(() => {
                });
        },
        get_ay_std() {
            this.overlay = true;
            axios
                .post("/CommonAPI/get_ay_std_div_for_report_by_access")
                .then((res) => {
                    this.overlay = false;
                    this.ay_std_div_list = res.data.data;
                    this.status_list = res.data.status_list.filter(item => item.id !== "3");
                    this.status = this.status_list[0];
                    this.document_list = res.data.document_list;

                    const list = res.data.quota_list;
                    this.quota_list = [
                        { id: "All", name: "All" },
                        ...list.map((item) => ({
                            ...item,
                            id: String(item.id),
                        })),
                    ];

                    this.quota = this.quota_list[0].id;
                })
                .catch((error) => {
                    this.overlay = false;
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getStudentList() {
            this.student_list=null;
            this.selected_student = null;
            let ay = null;
            if (this.sel_ay_data) {
                ay = this.sel_ay_data.ay_id || this.sel_ay_data.id;
            }

            let std = null;
            if (this.sel_std_data) {
                std = this.sel_std_data.std_id || this.sel_std_data.id;
            }

            let div = null;
            if (this.div) {
                div = this.div.div_off_id || this.div.id || this.div;
            }

            let status = null;
            if (this.status) {
                status = this.status.id || this.status;
            }

            const data = {
                ay: ay,
                std: std,
                div: div,
                status: status
            }
            this.overlay = true;
            this.fetch_btn_load=true;
            axios
                .post("/CommonAPI/getAllStudentList",data)
                .then((res) => {
                    this.overlay = false;
                    
                    const list = res.data.student_list || [];

                    if (list.length > 0) {
                        this.student_list = [
                            { id: "All", name: "All Students" },
                            ...list.map((item) => ({
                                ...item,
                                id: String(item.id),
                            })),
                        ];
                     this.selected_student = this.student_list[0];
                    }else{
                        this.student_list = [];
                        this.selected_student = null;
                        this.showSnackbar("#b71c1c", "No Students found");
                        return;
                    }
                    
                    this.quota = this.quota_list[0].id;
                    this.fetch_btn_load=false;
                })
                .catch((error) => {
                    this.overlay = false;
                    window.console.log(error);
                    
                })
                .finally(() => {
                    this.overlay = false;
                    this.fetch_btn_load=false;
                });
        },

        toggleCategory(category) {
            category.fields.forEach(item => {
                this.field[item.model] = category.selectAll;
            });

            this.updateGlobalSelectAll();
        },

        updateCategorySelectAll(category) {

            const selectedCount = category.fields.filter(
                item => this.field[item.model] === true
            ).length;

            category.selectAll =
                selectedCount === category.fields.length;

            this.updateGlobalSelectAll();
        },

        getSelectedCount(category) {

            return category.fields.filter(
                item => this.field[item.model] === true
            ).length;
        },

        updateGlobalSelectAll() {

            const allFields = this.fieldCategories.reduce(
                (fields, category) => fields.concat(category.fields),
                []
            );

            this.all_toggle = allFields.length > 0 &&
                allFields.every(item => this.field[item.model] === true);
        },

       showVaccinationAttachmentDialog(fl) {
            this.selected_vaccinations = [];
            
            if (fl.vaccination_attachment && fl.vaccination_attachment !== "NA") {
                const names = fl.vaccination_name ? fl.vaccination_name.split(',').map(s => s.trim()) : [];
                const dates = fl.vaccination_date ? fl.vaccination_date.split(',').map(s => s.trim()) : [];
                const compliances = fl.vaccination_iscompliance ? fl.vaccination_iscompliance.split(',').map(s => s.trim()) : [];
                const attachments = fl.vaccination_attachment.split(',').map(s => s.trim());

                for (let i = 0; i < attachments.length; i++) {
                    this.selected_vaccinations.push({
                        name: names[i] || 'NA',
                        date: dates[i] || 'NA',
                        compliance: compliances[i] || 'NA',
                        attachment: attachments[i] || 'NA'
                    });
                }
            }
            
            this.vaccination_dialog = true;
        },
        showHealthDocuments(fl) {
            this.selected_health_reports = [];
            
            if (fl.doc_attachment && fl.doc_attachment.length > 0) {
                for (let i = 0; i < fl.doc_attachment.length; i++) {
                    this.selected_health_reports.push({
                        name: fl.doc_name && fl.doc_name[i] ? fl.doc_name[i] : 'NA',
                        description: fl.doc_des && fl.doc_des[i] ? fl.doc_des[i] : 'NA',
                        date: fl.doc_date && fl.doc_date[i] ? fl.doc_date[i] : 'NA',
                        attachment: fl.doc_attachment[i]
                    });
                }
            }
            
            this.health_dialog = true;
        },
        showAwardDocuments(fl) {
            this.selected_awards = [];
            
            if (fl.doc_attachment && fl.doc_attachment.length > 0) {
                for (let i = 0; i < fl.doc_attachment.length; i++) {
                    this.selected_awards.push({
                        name: fl.doc_name && fl.doc_name[i] ? fl.doc_name[i] : 'NA',
                        description: fl.doc_des && fl.doc_des[i] ? fl.doc_des[i] : 'NA',
                        date: fl.doc_date && fl.doc_date[i] ? fl.doc_date[i] : 'NA',
                        attachment: fl.doc_attachment[i]
                    });
                }
            }
            this.award_dialog = true;
        },

        showActivityDetails(fl) {
            this.selected_activities = [];
            
            if (fl.doc_name && fl.doc_name.length > 0) {
                for (let i = 0; i < fl.doc_name.length; i++) {
                    this.selected_activities.push({
                        name: fl.doc_name[i] || 'NA',
                        role: fl.doc_role && fl.doc_role[i] ? fl.doc_role[i] : 'NA',
                        level: fl.doc_level && fl.doc_level[i] ? fl.doc_level[i] : 'NA',
                        description: fl.doc_des && fl.doc_des[i] ? fl.doc_des[i] : 'NA',
                    });
                }
            }
            this.activity_dialog = true;
        },

        showPaymentDetails(fl) {
            this.selected_payment_details = [];
            
            if (fl.payment_history && fl.payment_history.length > 0) {
                this.selected_payment_details = fl.payment_history;
            }
            this.payment_dialog = true;
        },
    },
    created() {
        this.awspath = localStorage.getItem("awspath");
        this.tenant = localStorage.getItem("EPS-tenant");
    },
    mounted() {
        this.get_ay_std();
        this.basepath = localStorage.getItem("awspath");
    },
};
</script>

<style scoped>
.text-color {
    color: red;
}

.mytable1 {
    overflow-x: scroll !important;
}

table,
th,
td {
    border: 1px solid rgb(201, 200, 200);
    border-collapse: collapse;
}

tbody,
td {
    font-weight: 400;
}

.regno :hover {
    cursor: pointer;
}

.section-heading {
    font-weight: 600;
    color: #0f2027;
    border-bottom: 1px solid #ddd;
    padding-bottom: 6px;
    margin: 16px 0 8px 0;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #fff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #ffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

.field-selection-wrapper {
    margin-top: 20px;
}

.field-selection-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 14px 18px;
    margin-bottom: 16px;

    border: 1px solid #dfe3e6;
    border-radius: 8px;

    background: #f7f9fa;
}

.field-selection-title {
    font-size: 17px;
    font-weight: 600;
    color: #0f2027;
}

.field-selection-subtitle {
    margin-top: 3px;
    font-size: 12px;
    color: #777;
}

.global-select {
    display: flex;
    align-items: center;
}

.global-select-label {
    font-size: 14px;
    font-weight: 600;
    color: #0f2027;
}


.field-category {
    border: 1px solid #dfe3e6;
    border-radius: 8px;

    margin-bottom: 16px;

    overflow: hidden;

    background: #ffffff;
}

.category-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    min-height: 58px;

    padding: 10px 16px;

    background: #f7f9fa;

    border-bottom: 1px solid #e2e5e7;
}

.category-title-wrapper {
    display: flex;
    align-items: center;
}

.category-icon {
    width: 34px;
    height: 34px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 10px;

    border-radius: 6px;

    background: #e9eef0;
}

.category-title {
    font-size: 15px;
    font-weight: 600;

    color: #0f2027;
}

.category-count {
    margin-top: 2px;

    font-size: 11px;

    color: #777;
}

.category-select-all {
    display: flex;
    align-items: center;
}

.select-all-label {
    font-size: 13px;
    font-weight: 600;
    color: #0f2027;
}



.category-fields {
    padding: 14px 16px 8px 16px;
}

.field-item {
    min-height: 38px;

    display: flex;
    align-items: center;

    padding: 5px 8px;

    border: 1px solid transparent;

    border-radius: 5px;

    transition: all 0.15s ease;
}

.field-item:hover {
    background: #f7f9fa;
    border-color: #dfe3e6;
}

.field-item-selected {
    background: #f3f6f7;
}

.field-label {
    font-size: 13px;
    color: #333;

    line-height: 18px;
}



.field-item .v-input {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.field-item .v-input--selection-controls {
    margin-top: 0 !important;
}

.category-select-all .v-input {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.scrollable-list {
    max-height: 120px; 
    overflow-y: auto;
    text-align: left;
    padding-right: 5px;
}

.scrollable-list::-webkit-scrollbar {
    width: 4px;
}
.scrollable-list::-webkit-scrollbar-track {
    background: #f1f1f1; 
}
.scrollable-list::-webkit-scrollbar-thumb {
    background: #888; 
    border-radius: 4px;
}
.scrollable-list::-webkit-scrollbar-thumb:hover {
    background: #555; 
}

/* @media print {
    .scrollable-list {
        max-height: none !important;
        overflow-y: visible !important;
    }
} */

@media print {
    body { margin: 10mm; padding: 0; }
    h2 { page-break-after: avoid; break-after: avoid; }
    table, tr, td, th { 
        page-break-inside: auto !important; 
        break-inside: auto !important; 
    }
    thead { display: table-header-group; }
    tfoot { display: none; }
}


@media (max-width: 600px) {

    .field-selection-header {
        display: block;
    }

    .global-select {
        margin-top: 8px;
    }

    .category-header {
        display: block;
    }

    .category-select-all {
        margin-top: 8px;
    }
}
</style>